import { render, staticRenderFns } from "./ModalAdvertisement.vue?vue&type=template&id=10d5e827&scoped=true"
import script from "./ModalAdvertisement.vue?vue&type=script&lang=js"
export * from "./ModalAdvertisement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d5e827",
  null
  
)

export default component.exports